import React from 'react';
import classNames from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import GenderEthnicLanguageDiversity from '../GenderEthnicLanguageDiversity';
import GenderOverTime from '../GenderOverTime';
import GenderRatioComparison from '../GenderRatioComparision';
import IncomeByGender from '../salaryEstimates/IncomeByGender';

import classes from './index.module.css';

const GenderStatistics = ({
  jobTitle,
  jobTitlePlural,
  genderPieChart,
  genderSectionContentBlurb,
  salaryEstimates,
  genderOverTime,
  genderOverTimeContentBlurb,
  filterLogEventCallback,
  filterValueRange,
  genderRatio,
  compareGenderContentBlurb,
  jobsIndex,
}) => {
  return (
    <section
      id="gender-statistics"
      className={classNames(classes.genderStatisticsContainer, 'w-730')}
    >
      <h2 className="brandonH2 w-730 z-mb-48">{`${jobTitle} Statistics By Gender`}</h2>
      {genderPieChart && (
        <>
          <GenderEthnicLanguageDiversity
            jobTitle={jobTitle}
            jobTitlePlural={jobTitlePlural}
            genderSetionContentBlurb={genderSectionContentBlurb}
            pieChartData={[genderPieChart]}
            filterLogEventCallback={filterLogEventCallback}
            filterValueRange={filterValueRange}
            noTitle
          />
          <div className="section-separator-medium"></div>
        </>
      )}

      {salaryEstimates && salaryEstimates.byGender && !_isEmpty(salaryEstimates.byGender) && (
        <IncomeByGender
          outsideTitle={`Gender Pay Gap For ${jobTitle}`}
          title={`Gender Pay Gap For ${jobTitle}`}
          jobTitle={jobTitle}
          incomeByGender={salaryEstimates.byGender}
        />
      )}

      {genderOverTime && (
        <GenderOverTime
          jobTitle={jobTitle}
          genderOverTime={genderOverTime}
          genderOverTimeContentBlurb={genderOverTimeContentBlurb}
        />
      )}

      {genderRatio && (
        <GenderRatioComparison
          filterLogEventCallback={filterLogEventCallback}
          filterValueRange={filterValueRange}
          jobTitle={jobTitle}
          genderRatio={genderRatio}
          compareGenderContentBlurb={compareGenderContentBlurb}
          jobsIndex={jobsIndex}
        />
      )}
    </section>
  );
};

export default GenderStatistics;
